"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._Owner = {
    type: "structure",
    required: [],
    members: {
        DisplayName: {
            shape: {
                type: "string"
            }
        },
        ID: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=_Owner.js.map